module.exports = __webpack_public_path__ + "images/joshua_jodesty.jpg?v=0902abef1504388cc7f4aaccb7300043";